import React from "react";
import { DisconnectionInfoPage } from "./DisconnectionInfoPage";
import { DisconnectionImportantInfoPageContent } from "../../types/DisconnectionImportantInfoPageContent";

export const EMPTY_DISCONNECTION_IMPORTANT_INFO_PAGE_CONTENT: DisconnectionImportantInfoPageContent =
  {
    tabTitle: "",
  };

export const DisconnectionInfoPageContainer: React.FC = () => {
  return (
    <DisconnectionInfoPage
      {...EMPTY_DISCONNECTION_IMPORTANT_INFO_PAGE_CONTENT}
    />
  );
};
